import type { RunnerRegistry } from './types';
import { researchRunner } from './research';
import { promptFillRunner } from './promptFill';
import { imageGenerateRunner } from './imageGenerate';
import { compositeRunner } from './composite';

export const RUNNERS: RunnerRegistry = {
  composite: compositeRunner,
  research: researchRunner,
  'prompt-fill': promptFillRunner,
  'image-generate': imageGenerateRunner,
};

export type { Runner, RunnerContext, RunnerRegistry, RunnerResult } from './types';
